export const generateCSV = (groups: any[], initial: string[][]) => {
  const rows: string[][] = [...initial, ...groups];
  const csvContent =
    "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
  const uri = encodeURI(csvContent);
  return uri;
};
